// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Record_Extra2 from "../Data.Record.Extra2/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Menu_V2_Parametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var paymentMethod = function (menuEnv1) {
    var v = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId)(Restaumatic_Menu_V2_Types_InternalParameterId.PaymentMethod.value)(menuEnv1.params);
    if (v instanceof Data_Maybe.Just && v.value0 instanceof Restaumatic_Menu_V2_Types_InternalParameterChoiceId.PaymentMethodChoice) {
        return new Data_Maybe.Just(v.value0.value0);
    };
    return Data_Maybe.Nothing.value;
};
var menuEnv = function (catalogue) {
    return function (locale) {
        return function (localDateTimeD) {
            return function (fulfillmentMethodD) {
                return function (paymentMethodD) {
                    return function (originD) {
                        var schedules = Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(localDateTimeD)(function (localDateTime) {
                            return Data_Functor.map(Data_Map_Internal.functorMap)(Restaumatic_UnwrapOperators.composeFlippedUnwrapArg()(function (v) {
                                return v.availability;
                            })(Data_Function.flip(Restaumatic_Calendar_Types_Availability.isAvailable)(localDateTime)))(Restaumatic_UnwrapOperators.applyUnwrapUnwrappedFlipped()()(catalogue)(function (v) {
                                return v.availabilitySchedules;
                            }));
                        });
                        var schedulesArray = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray))(schedules);
                        var calculateSchedule = function (v) {
                            return new Data_Tuple.Tuple(new Restaumatic_Menu_V2_Types_InternalParameterId.Schedule(v.value0), new Restaumatic_Menu_V2_Types_InternalParameterChoiceId.ScheduleChoice(v.value1));
                        };
                        var scheduleInternalParams = Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
                            var $15 = Data_Map_Internal.fromFoldable(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId)(Data_Foldable.foldableArray);
                            var $16 = Data_Functor.map(Data_Functor.functorArray)(calculateSchedule);
                            return function ($17) {
                                return $15($16($17));
                            };
                        })())(schedulesArray);
                        var params = Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_FRP_Base.monoidDynamic(Data_Map_Internal.monoidMap(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId)))([ Data_Functor.map(Specular_FRP_Base.functorDynamic)(function ($18) {
                            return (function (v) {
                                return Restaumatic_Menu_V2_Parametric.mapAssign(Restaumatic_Menu_V2_Types_InternalParameterId.Origin.value)(v);
                            })(Restaumatic_Menu_V2_Types_InternalParameterChoiceId.OriginChoice.create($18));
                        })(originD), Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe(Data_Map_Internal.empty)(function (fm) {
                            return Restaumatic_Menu_V2_Parametric.mapAssign(Restaumatic_Menu_V2_Types_InternalParameterId.FulfillmentMethod.value)(new Restaumatic_Menu_V2_Types_InternalParameterChoiceId.FulfillmentMethodChoice(fm));
                        }))(fulfillmentMethodD), Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe(Data_Map_Internal.empty)(function (pm) {
                            return Restaumatic_Menu_V2_Parametric.mapAssign(Restaumatic_Menu_V2_Types_InternalParameterId.PaymentMethod.value)(new Restaumatic_Menu_V2_Types_InternalParameterChoiceId.PaymentMethodChoice(pm));
                        }))(paymentMethodD), scheduleInternalParams ]);
                        return Data_Record_Extra2.rsequence()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                            reflectSymbol: function () {
                                return "locale";
                            }
                        })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                            reflectSymbol: function () {
                                return "params";
                            }
                        })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                            reflectSymbol: function () {
                                return "schedules";
                            }
                        })()(Specular_FRP_Base.functorDynamic)()())()())()())({
                            locale: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(locale),
                            params: params,
                            schedules: schedules
                        });
                    };
                };
            };
        };
    };
};
var fulfillmentMethod = function (menuEnv1) {
    var v = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId)(Restaumatic_Menu_V2_Types_InternalParameterId.FulfillmentMethod.value)(menuEnv1.params);
    if (v instanceof Data_Maybe.Just && v.value0 instanceof Restaumatic_Menu_V2_Types_InternalParameterChoiceId.FulfillmentMethodChoice) {
        return new Data_Maybe.Just(v.value0.value0);
    };
    return Data_Maybe.Nothing.value;
};
var emptyMenuEnv = /* #__PURE__ */ (function () {
    return {
        locale: Restaumatic_Locales.PL.value,
        params: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId)),
        schedules: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))
    };
})();
export {
    emptyMenuEnv,
    menuEnv,
    fulfillmentMethod,
    paymentMethod
};
//# sourceMappingURL=index.js.map
